import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { delPdtWishList, loadPdtWishList, savePdtWishList } from '@app/actions/shoppingmall/wishlist-pdt.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { CommonConstant } from '@app/common/constant/common.constant';
import { MemberConstants } from '@app/common/constant/member.constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { CommonUtils } from '@app/common/util/common.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ParameterUtils } from '@app/common/util/parameter.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { PdtCateModel } from '@app/models/shoppingmall/pdt-cate.model';
import { MemberModel } from '@app/models/system/member.model';
import { SmPayHeaderModel } from '@app/models/system/sm-pay-header.model';
import { SmWownetPgModel } from '@app/models/system/sm-wownet-pg.model';
import { WownetWordModel } from '@app/models/system/wownet-word.model';
import { CartState, getCartInfo } from '@app/selectors/shoppingmall/cart.selector';
import { PdtCateState, getPdtCates } from '@app/selectors/shoppingmall/pdt-cate.selector';
import { ProductState, getSpecialProducts } from '@app/selectors/shoppingmall/product.selector';
import { PdtWishListState, getPdtWishList } from '@app/selectors/shoppingmall/wishlist-pdt-selector';
import { getFindPayHeader, getSmWownetPg, getWowWord, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { CartService } from '@app/services/shoppingmall/cart.service';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

declare const bestProductSwiper: any;
declare const getYnPayHeader: any;

@Component({
  selector: 'hp-best',
  templateUrl: './hp-best.component.html',
  styleUrls: ['./hp-best.component.css']
})
export class HpBestComponent implements OnInit {
  @Input() urlWownet : string = "";

  @Output() itemProduct = new EventEmitter<OrdPdtModel>();

  smWownetPg$ = new Observable<SmWownetPgModel>();
  smWownetPg: any = {} as SmWownetPgModel;

  pdtCates$ = new Observable<PdtCateModel[]>;

  products$ = new Observable<OrdPdtModel[]>();
  products: OrdPdtModel[] = [];

  cartInfo$ = new Observable<OrderMstModel[]>();
  cartInfo: OrderMstModel[] = {} as OrderMstModel[];

  wishList$ = new Observable<OrdPdtModel[]>();
  wishList : OrdPdtModel[] = {} as OrdPdtModel[];

  quantities: number[] = [];

  productfilters: OrdPdtModel[] = [];

  contentsPdtCates : any = "";
  
  wishYn: string[] = [];
  ordNoTmp: string = '';
  linkGuest: string = 'N';
  activeCateCd: string = "";

  isLogin: boolean = AuthUtil.isLogined();
  isPoint: boolean = false;
  isConsumer : boolean = false;
  isPv1: boolean = false;
  isPv2: boolean = false;
  isPv3: boolean = false;

  smWowWord$ = new Observable<WownetWordModel>();
  smWowWord: any = {} as WownetWordModel;
  smPayHeader$ = new Observable<SmPayHeaderModel>();

  loginInfo: MemberModel | null = null;
  GRP_AREKHAN = environment.comCd + MemberConstants.GRP_AREKHAN;
  
  constructor(
    private _pdtCateStore: Store<PdtCateState>,
    private _productStore: Store<ProductState>,
    private _cartStore: Store<CartState>,
    private _wishListStore: Store<PdtWishListState>,
    private _wAlertStore: Store<WAlertState>,
    private _cartService: CartService,
    private _smWownetStateStore: Store<SmWownetState>) { 

    this.pdtCates$ = this._pdtCateStore.select(getPdtCates);
    this.products$ = this._productStore.select(getSpecialProducts);
    this.cartInfo$ = this._cartStore.select(getCartInfo);
    this.smWownetPg$ = this._smWownetStateStore.select(getSmWownetPg);
    this.wishList$ = this._wishListStore.select(getPdtWishList);
    this.smWowWord$ = this._smWownetStateStore.select(getWowWord);
    this.smPayHeader$ = this._smWownetStateStore.select(getFindPayHeader);
  }

  ngOnInit(): void {
    let linkG = sessionStorage.getItem(CommonConstant.LINK_GUEST);
    this.linkGuest = ConvertUtil.convertToString(linkG);
    setTimeout(() => {
      this.isConsumer = CommonUtils.isConsumer();
    }, 1000);

    if(this.isLogin){   
      this.loginInfo = AuthUtil.getLoginedInfo();
    }

    this.smPayHeader$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.isPv1 = getYnPayHeader(res, "pv1");
        this.isPv2 = getYnPayHeader(res, "pv2");
        this.isPv3 = getYnPayHeader(res, "pv3");
      }
    });

    this.smWowWord$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.smWowWord = res;
      }
    });

    this.pdtCates$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.contentsPdtCates = res.filter(x => x.lv == "1" && x.cateNameOrg == 'GENERAL');

        if (ValidationUtil.isNotNullAndNotEmpty(this.contentsPdtCates)) {
          this.activeCateCd = this.contentsPdtCates[0].cateCd;
        }
      }
    });

    this.products$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {

        this.products = res.filter(x=> x.bestYN === 'Y');
        this.productfilters = this.products.filter(x=> x.cateCD === this.activeCateCd || x.pcateCd === this.activeCateCd);

        setTimeout(() => {
          bestProductSwiper();
          this.productChange();
        }, 500);
      }
    });

    this._cartStore.select(getCartInfo).subscribe(res => {
      this.cartInfo = res;
    });
    this.smWownetPg$.subscribe(res => this.isPoint = res.mpoint === CommonConstant.YES);

    this.wishList$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.wishList = res;
      }
    });
  }

  productChange(){
    let length = this.productfilters.length;
    this.quantities = new Array(length);
    this.wishYn = new Array(length);
    for (let i = 0; i < length; i++) {
      this.quantities[i] = 1;
      this.wishYn[i] = ConvertUtil.convertToString(this.productfilters[i].wishYN);
    }
  }

  handleOnclickCategory(item: any){
    this.activeCateCd = item.cateCd;
    this.productfilters = this.products.filter(x=> x.cateCD === this.activeCateCd || x.pcateCd === this.activeCateCd);
    setTimeout(() => {
      bestProductSwiper();
    }, 500);
  }

  handleOnClickProductDetail(item: any): void {
    this.itemProduct.emit(item);
  }

  handleOnAddToCart(index: number): void {
    if (index >= 0 && index < this.quantities.length && index < this.productfilters.length) {
      let item = this.productfilters[index];
      let quantity = this.quantities[index];

      if (this.isLogin) { 
        this._cartService.addCartItemLogin(item, quantity, this.cartInfo);
      } else {
        this._cartService.addCartItemNotLogin(item, quantity);
      }
    } 
  }

  handleOnclickAddWishList(item: any, index: any):void{
    if (!this.isLogin) {
      this.showAlertRequiredLogin();
    } else {
      let member = AuthUtil.getLoginedInfo();
      let userId = '';
      if (member) {
        userId = ConvertUtil.convertToString(member.userid);
      }

      if(ValidationUtil.isNotNullAndNotEmpty(this.wishList)) {
        if(this.wishList.filter(v => v.pdtCd === item.pdtCd).length === 0) {
          this.wishYn[index] = CommonConstant.YES;
          this._wishListStore.dispatch(savePdtWishList({userid: userId, pdtCd: item.pdtCd}));
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: MessageConstant.MSG_ADD_WISH_ITEM_SUCCESS } }));
        } else {
          this.wishYn[index] = CommonConstant.NO;
          this._wishListStore.dispatch(delPdtWishList({userid: userId, pdtCd: item.pdtCd}));
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: MessageConstant.MSG_DELETE_WISH_ITEM_SUCCESS } }));
        }     
      } else {
        this.wishYn[index] = CommonConstant.YES;
        this._wishListStore.dispatch(savePdtWishList({userid: userId, pdtCd: item.pdtCd}));
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: MessageConstant.MSG_ADD_WISH_ITEM_SUCCESS } }));
      }
      this._wishListStore.dispatch(loadPdtWishList({params : ParameterUtils.getPdtWishListParams("", "", 100, 0,  "PC")}));
    }
  }

  showAlertRequiredLogin(): void {
    this._wAlertStore.dispatch(
      setWAlert({ 
        wAlert: { 
          icon: WAlertConstant.confirm, 
          message: MessageConstant.msgRequiredLogin, 
          action: ActionConstant.actionConfirmLogined 
        } 
      })
    );
  }
}
